import { render, staticRenderFns } from "./viewTarget.vue?vue&type=template&id=538d8e23&"
import script from "./viewTarget.vue?vue&type=script&lang=js&"
export * from "./viewTarget.vue?vue&type=script&lang=js&"
import style0 from "./viewTarget.vue?vue&type=style&index=0&id=538d8e23&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports